export default "__VITE_ASSET__BBE$3aoq__"